export default function canShowTab(user, allowedRoles: Array<string>) {
  const hasPermittedRole = allowedRoles.some((allowedRole) => {
    return user?.roles.includes(allowedRole);
  });

  // user can see the tab if they have one of the approved roles
  return hasPermittedRole;
}
